// Build timestamp: 2026-02-17T12:10:00Z
// This file forces Vercel to detect changes
export const BUILD_VERSION = '1.0.1';
